import { assets } from '@/assets';
import { cx } from '@/lib/cx';
import styles from './TongueSidesDiagram.module.css';

/**
 * The roof of the mouth seen from below (the view SLPs use for electropalatography), with what
 * the cue asks for drawn on it: the sides of the tongue pressed along the inside of the back
 * teeth on both sides (pulsing gently). An airflow arrow was removed: a blind review read it as
 * "slide your tongue along the roof", the wrong movement.
 * Coordinates are the art's own (art/coach/tongue-sides.png, 1448 x 1010).
 */
const W = 1448;
const H = 1010;
// Along the inner edge of the upper molars, front to back (left side; the right is mirrored).
const SIDE = 'M432 505 C402 595 362 685 334 775 S296 905 288 975';

interface TongueSidesDiagramProps {
  label: string;
  className?: string;
}

export function TongueSidesDiagram({ label, className }: TongueSidesDiagramProps) {
  return (
    <svg
      className={cx(styles.root, className)}
      viewBox={`0 0 ${String(W)} ${String(H)}`}
      role="img"
      aria-label={label}
    >
      <image href={assets.coach.tongueSides.url} width={W} height={H} />
      <g className={styles.sides}>
        {['', `translate(${String(W)} 0) scale(-1 1)`].map((mirror) => (
          <g key={mirror} transform={mirror || undefined}>
            <path d={SIDE} />
            <path d={SIDE} className={styles.highlight} />
          </g>
        ))}
      </g>
    </svg>
  );
}
